import { useState } from "react";
import { Button, Box } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import NewAppearanceDialog from "./NewAppearanceDialog";

const NewAppearanceButton = (props) => {
  const [open, setOpen] = useState(false);

  return (
    <div>
      <Button
        data-testid="newAppearanceButton"
        sx={{ marginLeft: 1 }}
        variant="contained"
        onClick={() => setOpen(true)}
      >
        <AddIcon />
        Create Appearance
      </Button>

      <NewAppearanceDialog
        open={open}
        setOpen={setOpen}
        matchId={props.matchId}
        teamId={props.teamId}
        players={props.players}
      ></NewAppearanceDialog>
    </div>
  );
};

export default NewAppearanceButton;
